import React from "react";
import ReactTypingEffect from "react-typing-effect";


const TypedText = (props) => {
    return(
        <>
            <ReactTypingEffect
                text={["Mostafa Abdelaziem", "Front-End Developer"]}
                cursorRenderer={cursor => <h1>{cursor}</h1>}
                displayTextRenderer={(text, i) => {
                return (
                    <h1>
                    {text.split('').map((char, i) => {
                        const key = `${i}`;
                        return (
                        <span key={key}
                        style={{
                            color: document.body.classList.contains('dark-theme') ? '#fff' : '#50566a',
                            fontSize:'20px'}
                        }
                        >{char}</span>
                        );
                    })}
                    </h1>
                );
                }}        
            />
        </>
    )

}



export default TypedText